var map = {
	"./adaware.png": 4160,
	"./avast.png": 3036,
	"./avira.png": 5014,
	"./bitdefender.png": 9778,
	"./clamav.png": 2095,
	"./comodo.png": 5136,
	"./drweb.png": 7148,
	"./emsisoft.png": 7104,
	"./escan.png": 8473,
	"./eset.png": 4102,
	"./fprot.png": 9752,
	"./fsecure.png": 1413,
	"./gdata.png": 2787,
	"./kaspersky.png": 4974,
	"./mcafee.png": 3182,
	"./nsrl.png": 1879,
	"./padvish.png": 3033,
	"./question.png": 3658,
	"./quickheal.png": 9725,
	"./sanitizer.png": 6366,
	"./sophos.png": 4285,
	"./symantec.png": 8999,
	"./trendmicro.png": 5297,
	"./vulnerabilitydetection.png": 1079,
	"./windowsdefender.png": 9314,
	"./yara copy.png": 9561,
	"./yara.png": 2150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;